<template>
  <div class="passport-page">
    <v-sheet class="folded-corner passport-panel">
      <v-container>
        <v-card
          elevation="0"
          class="align-center pa-4 mx-auto"
        >
              <ChangeLanguage />
              <v-row
                style="    display: flex;
    justify-content: flex-end;padding-right: 40px;padding-top: 10%"
              >
                <v-progress-circular indeterminate size="100 "></v-progress-circular>
              </v-row>

              <v-row style="margin-top: 10%">
                <v-col
                  cols="12"
                  md="12"
                  style="
                    text-align: center;
                    font-size: 60px;
                    color: #126496;
                    font-weight: bold;
                  "
                >
                  <!-- Please insert your ID card. -->
                  {{ $t("message.PleaseinsertPassport") }}
                </v-col>
              </v-row>
              <v-row style="margin-top: 20%">
                <v-col cols="12" md="12" style="text-align: center">
                  <img
                    @click="CapturePerson()"
                    height="auto"
                    width="450px"
                    style="
                      padding-top: 0rem;
                      margin-left: auto;
                      margin-right: auto;
                      cursor: pointer;
                    "
                    src="@/assets/passport.png"
                  />
                </v-col>
              </v-row>
              <v-row style="margin-top: 25%">
                <v-col cols="12" md="12" style="text-align: center">
                  <v-btn
                    color="#344054"
                    class="box white--text mt-2 text-capitalize"
                    router
                    width="500"
                    style="font-size: 45px"
                    height="100"
                    @click="BackToIdentifySelection()"
                    >{{ $t("message.Back") }}</v-btn
                  >
                </v-col>
              </v-row>
        </v-card>
      </v-container>
    </v-sheet>

    <!-- <v-progress-circular v-model="LoadingDialog"
          :size="70"
          :width="7"
          color="purple"
          indeterminate
        ></v-progress-circular> -->

    <v-overlay v-model="LoadingDialog">
      <v-progress-circular indeterminate size="64">
        Loading...
      </v-progress-circular>
    </v-overlay>

    <!-- <v-dialog v-model="LoadingDialog" >

        <v-progress-circular
          :size="70"
          :width="7"
          color="purple"
          indeterminate
        ></v-progress-circular>

    </v-dialog> -->
  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import ChangeLanguage from "@/components/ChangeLanguage";
export default {
  name: "NationalIDCard",
  components: {
    ChangeLanguage,
  },
  data() {
    return {
      url: enurl.apiUrl,
      urlReader: enurl.apiReaderUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      LoadingDialog: false,
      PersonData: "",
      warningDialog: false,
      passportReaderInterval: null,
      ResponsePassport: [],
      thaiPersonalInfo: [],
      englishPersonalInfo: [],
    };
  },

  mounted: function() {
    setInterval(() => {
      this.getCurrentDate();
    }, 1000);

    this.passportReaderInterval = setInterval(() => {
      this.getDataPassportReader();
    }, 3000);

  },

  beforeDestroy() {
    if (this.passportReaderInterval) {
      clearInterval(this.passportReaderInterval);
      this.passportReaderInterval = null;
    }
  },

  methods: {
    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${
        month < 10 ? `0${month}` : `${month}`
      }/${year}  ${hours}:${minutes}:${seconds}`;
    },

    getDataPassportReader() {
      let self = this;
      axios
        .get(`${self.urlReader}PassportReader/PassportReader`)
        .then(function(response) {
          if (response.data.status == 0) {
            // self.PersonData = response.data.data;
            self.ResponsePassport = response.data.data;
            self.LoadingDialog = false;
            // self.$router.push("/CapturePerson");
            // console.log(self.PersonData);

            let temp = {
              documentNumber: self.ResponsePassport.idCard,
              prefixEN: "",
              firstnameEN: self.ResponsePassport.firstNameEng,
              middlenameEN: "",
              lastnameEN: self.ResponsePassport.lastNameEng,
              sexEN: self.ResponsePassport.sex == 'M' ? '1' : '2',
              prefixTH: "",
              firstnameTH: self.ResponsePassport.firstNameEng,
              middlenameTH: "",
              lastnameTH: self.ResponsePassport.lastNameEng,
              sexTH: self.ResponsePassport.sex == 'M' ? '1' : '2',
              type: "Passport",
              image1: "",
              image2: "",
              tenantID: 0,
              towerID: 1,
              zoneID: 0,
              floorID: 0,
              locationID: 0,
            };

            self.$router.push({
              name: "CapturePerson",
              path: "/CapturePerson",
              params: {
                data: temp,
              },
            });

            // self.CapturePerson();
          }
        })
        .catch(function(error) {
          self.MessageAlert = error;
        });
    },

    BackToIdentifySelection() {
      let self = this;
      self.$router.push("/IdentifySelection");
    },

    BackToMain() {
      let self = this;
      self.$router.push("/MainMenu");
    },

    CapturePerson() {
      let self = this;
      self.getDataPassportReader();
      // self.$router.push("/CapturePerson");
    },
  },
};
</script>
<style scoped>
.passport-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(28px, 5vw, 72px);
}

.passport-panel {
  min-height: 0 !important;
}

.passport-page img {
  width: min(27vw, 360px) !important;
}

.passport-page .v-progress-circular {
  color: #344054;
}

.passport-page .v-btn.box {
  font-size: clamp(30px, 2.8vw, 45px) !important;
  height: 92px !important;
}

@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }
}
@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}
</style>
